<script lang="ts" setup>
import type { ApiCommentGetAllReaction } from '~/types'
import type { CommentReactionType } from '~/prisma/enums'

const props = defineProps<{
  isReadOnly: boolean
  reactionsByType: Partial<Record<CommentReactionType, ApiCommentGetAllReaction[]>>
  userSelectedReaction?: ApiCommentGetAllReaction
}>()
const emit = defineEmits<{
  (e: 'handleReactionClick', payload: CommentReactionType): void
}>()

const reactionsByTypeEntries = computed(() => Object.entries(props.reactionsByType) as [CommentReactionType, ApiCommentGetAllReaction[]][])

function selectReaction(type: CommentReactionType) {
  if (!props.isReadOnly) {
    emit('handleReactionClick', type)
  }
}
</script>

<template>
  <div class="flex gap-1 flex-wrap items-center">
    <n-popover
      v-for="[type, reactions] in reactionsByTypeEntries"
      :key="type"
      trigger="hover"
      placement="top-start"
    >
      <template #trigger>
        <n-button
          type="primary"
          size="small"
          :secondary="userSelectedReaction?.type === type"
          :tertiary="userSelectedReaction?.type !== type"
          @click="selectReaction(type)"
        >
          <template #icon>
            <span class="text-sm">
              {{ commentReactionConfig[type] }}
            </span>
          </template>
          <span class="text-gray-800">
            {{ reactions.length }}
          </span>
        </n-button>
      </template>
      <p class="text-xs">
        {{ reactions.map(({ createdBy }) => createdBy.name ?? createdBy.email).join(', ') }}
      </p>
    </n-popover>
  </div>
</template>
